import { Color } from "../enums/Color";

export const pagination = {
    mobile: {
        display: "flex",
        flexDirection: "row" as "row",
        width: "fit-content",
        margin: "9.66vw auto 0 auto",
        alignItems: "center" as "center",
        nextButton: {
            width: "9.66vw",
            height: "9.66vw",
            backgroundColor: Color.Green,
            borderColor: Color.SharpGreen,
            border: "1.2vw solid " + Color.SharpGreen,
            marginLeft: "8.45vw",
            borderRadius: "50%",
            cursor: "pointer",
            fill: Color.White
        },
        previousButton: {
            width: "7.24vw",
            height: "7.24vw",
            marginRight:"7.06vw",
            backgroundColor: Color.LightAsh,
            borderRadius: "50%",
            cursor: "pointer",
            fill: Color.SharpAsh
        },
        button: {
            padding: "0 2.29vw",
            minWidth: "6.03vw",
            height: "6.03vw",
            marginLeft: "1.39vw",
            border: "none",
            borderRadius: "0.72vw",
            backgroundColor: "transparent",
            color: Color.DeepAsh,
            cursor: "pointer",
            fontSize: "2.89vw",
            active: {
                backgroundColor: Color.DeepBlack,
                color: Color.White
            }
        },
        dots: {
            marginLeft: "1.39vw"
        },
        arrowIcon: {
            width: "3.86vw",
            height: "3.86vw"
        }
    },
    desktop: {
        margin: "2.60vw auto 5vw auto",
        nextButton: {
            width: "3.6vw",
            height: "3.6vw",
            marginLeft: "1.56vw",
            borderRadius: "50%",
            border: "0.5vw solid " + Color.SharpGreen,
            lessMargin: {
                marginLeft: "0.86vw"
            }
        },
        previousButton: {
            width: "2.60vw",
            height: "2.60vw",
            marginRight: "0.86vw",
            borderRadius: "50%",
            lessMargin: {
                marginRight: "0.16vw"
            }            
        },
        button: {
            marginLeft: "0.70vw",
            padding: "0 0.70vw",
            minWidth: "1.82vw",
            height: "1.82vw",
            borderRadius: "0.36vw",
            fontSize: "0.78vw"
        },
        dots: {
            marginLeft: "0.70vw"
        },
        arrowIcon: {
            width: "0.83vw",
            height: "0.83vw"
        }
    }
}